import type { AxiosProgressEvent } from "axios";
import type LxcError from "~/core/models/LxcError.class";
import RestService from "~/core/services/rest.service";
import type { License } from "~/modules/license/models/License.interface";
import organizationService from "~/modules/organization/services/organization.service";

export class LicenseService extends RestService {
  async getActiveLicenseInformation(
    organizationCode?: number,
  ): Promise<License | LxcError> {
    return this.$apiV2.get(
      `${this.getOrganizationLicensePath(organizationCode)}/active`,
    );
  }

  async uploadLicenseFile(
    file: File,
    progress: Ref<number | undefined | null>,
    organizationCode?: number,
  ): Promise<void> {
    const formData = new FormData();
    formData.append("license", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        progress.value = progressEvent.total
          ? (progressEvent.loaded / progressEvent.total) * 100
          : 0;
      },
      timeout: Infinity,
    };

    return this.$apiV2.post(
      this.getOrganizationLicensePath(organizationCode),
      formData,
      config,
    );
  }

  private getOrganizationLicensePath(organizationCode?: number) {
    return `${organizationService.getOrganizationPath(organizationCode)}/license`;
  }
}
export default new LicenseService();
